import { Injectable } from '@angular/core';
import { UserDataService } from './data-access/user-data.service';
import { PhotoReviewService } from './data-access/photo-review.service';
import { UsersService } from './data-access/users.service';
import { BadgeRequestsService } from './data-access/badge-requests.service';
import {EmployeeService} from './data-access/employee.service';
import { ManualActionsService } from './data-access/manual-actions.service';
import { StaticDataService } from './data-access/static-data-service';
import { BulkProvisionApiService } from './data-access/bulk-provision.api.service';

@Injectable({
    providedIn: 'root'
})
export class EmployeeDataAccessService {

    constructor(
        public photoReviewService: PhotoReviewService,
        public userData: UserDataService,
        public usersService: UsersService,
        public badgeRequestsService: BadgeRequestsService,
        public employeeService: EmployeeService,
        public manualActionsService: ManualActionsService,
        public staticDataService: StaticDataService,
        public bulkProvisionApiService: BulkProvisionApiService,
    ) {
    }
}
